import { type KeyboardEvent } from 'react'
import { InputBase } from '@mui/material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'

import { SOAP_LINE_HEIGHT_RATIO, soapLineFontSize } from './soapSections'

interface Props {
  value: string
  onChange: (value: string) => void
  onBlur: () => void
  onKeyDown: (e: KeyboardEvent) => void
}

// 表示行と地続きに見せる枠なし inline 編集入力. outlined TextField の枠線/大 padding による
// 行高肥大 (= 太さ不一致) を避ける. 既存行の編集 (SoapLine) と新規行 (SoapBody) で共用し、
// 字格 (fontSize / lineHeight) のドリフトを 1 箇所に封じる. Enter/Escape/blur の意味づけは
// 呼び出し側でハンドラとして渡す (編集中 = saveEdit / 新規 = saveNewLine 等).
export const EditInputBase = ({
  value,
  onChange,
  onBlur,
  onKeyDown,
}: Props) => (
  <InputBase
    autoFocus
    fullWidth
    multiline
    value={value}
    onChange={(e) => onChange(e.target.value)}
    onBlur={onBlur}
    onKeyDown={onKeyDown}
    sx={{
      p: 0,
      fontSize: soapLineFontSize,
      lineHeight: SOAP_LINE_HEIGHT_RATIO,
      color: colorTokens.fg.default,
      '& textarea': { p: 0 },
    }}
  />
)
